<template>
    <div>
       <div class="custom-status-circle" 
       :style="{ backgroundColor: colorsStatus[status]}">
      </div>
    </div>
</template>

<script>
  export default {
    props: {
      status: {
        type: String,
        default: 'unknow'
      }
    },
    data() {
      return {
        msg: 'Hi there!',
        colorsStatus: {
          wait: 'orange',
          running: 'green',
          finished: 'grey',
          unknow: 'lightgrey'
        }
      }
    }
  }
</script>

<style scoped>
  .custom-status-circle {
    width: 16px;
    height: 16px;
    background-color: grey;
    border-radius: 50%;
    margin: 8px;
  }
</style>